import { Box, Center, Flex, Link, Spinner, Text } from "@chakra-ui/react";
import BaseImage from "@components/BaseImage";
import { TransactionType } from "../../constants/types";
import FooterButtons from "./components/FooterButtons";
import { TransactionIconMapping } from "./utils";

import DefiTopOpportunity from "./components/DefiTopOpportunity";

interface SuccessErrorModalBodyTemplateProps {
  transactionType?: TransactionType;
  isSpinnerRequired?: boolean;
  modalTitle: string;
  modalSubTitle?: string;
  primaryBtnTxt?: string; // view transactions
  secondaryBtnTxt?: string; // close or cancel
  onSubmitPrimary?: () => void;
  onSubmitSecondary?: () => void;
  onTxView?: () => void;
}

const StakeSuccess = ({
  isSpinnerRequired = false,
  transactionType,
  modalTitle,
  modalSubTitle,
  primaryBtnTxt,
  secondaryBtnTxt,
  onTxView,
  onSubmitPrimary,
  onSubmitSecondary,
}: SuccessErrorModalBodyTemplateProps) => {
  return (
    <Center
      textAlign="center"
      flexDir="column"
      w="100%"
      paddingX={{ base: "0", md: "0" }}
      borderRadius="1.5rem"
      mt={{ base: "32px", md: "48px" }}
    >
      {isSpinnerRequired && (
        <Center h="160px" w="160px">
          <Spinner
            size="xl"
            thickness="4px"
            speed="0.75s"
            color="textPrimary"
          />
        </Center>
      )}
      {transactionType && (
        <BaseImage
          src={TransactionIconMapping[transactionType].icon}
          width={48}
          height={48}
          alt="icon"
        />
      )}
      <Text
        mt={isSpinnerRequired ? "1rem" : "2rem"}
        fontSize={{
          base: "20px",
          md: "24px",
        }}
        lineHeight="28px"
        color="#1A1A1A"
      >
        {modalTitle}
      </Text>

      <Flex
        mt="0.5rem"
        fontSize="12px"
        fontWeight="400"
        textAlign="center"
        color="textSecondary"
        gap="4px"
      >
        <Text>{modalSubTitle}</Text>
        <Link
          isExternal
          borderBottom="1px dashed"
          borderColor="textSecondary"
          onClick={onTxView}
        >
          View Transaction
        </Link>
      </Flex>

      <div className="bg-[#f4f4f7] w-full pb-6 flex flex-col gap-4 md:gap-6 mt-6 px-4 md:px-6 rounded-b-[1.5rem]">
        <Text
          color="textSecondary"
          mt={{ base: "20px", md: "24px" }}
          fontWeight="400"
          fontSize={{ base: "13px", md: "14px" }}
          lineHeight="20px"
          className="px-2 md:px-24"
        >
          Maximise your rewards with exclusive DeFi opportunities!
        </Text>
        <DefiTopOpportunity type="restake" />

        {primaryBtnTxt || secondaryBtnTxt ? (
          <Box>
            <FooterButtons
              secondaryBtnTxt={secondaryBtnTxt}
              onSubmitSecondary={onSubmitSecondary}
              primaryBtnTxt={primaryBtnTxt}
              onSubmitPrimary={onSubmitPrimary}
            />
          </Box>
        ) : null}
      </div>
    </Center>
  );
};

export default StakeSuccess;
